import React, { useEffect, useState } from "react";
import "./ConversationStyleSheet.css";
import { CircularProgress, IconButton, Typography } from "@mui/material";
import { ArrowBack, Download } from "@mui/icons-material";
import { s360ConfigService } from "../Services/S360Config";
import { loadLocalUser } from "../Services/HWIframeBridge";
import { usePrimaryIdentification } from "../../context/PrimaryIdentificationContext";
import apiService from "../Services/APIService";

import {
  findFirstActiveObject,
  getCookieForContactDetails,
} from "./utils/ConversationUtils";

import { convertEpochToDate } from "../../utils/dateConversion";
import {
  DATA_TEST_ID_PREFIX,
  LIVECHAT_CLICK_EVENTS,
} from "../../utils/Constants/statsig.constants";
import ticketStatus from "./utils/ticketStatus.constants";
import { useNetworkStatus } from "../../context/NetworkContext";

function NCXChatHistory(props) {
  const { isOnline } = useNetworkStatus();
  const {
    onClickBack,
    downloadHistory,
    downloadInProgress,
    userFromLanding,
    landingPageActions,
  } = props;
  const [tableDataOld, setTableDataOld] = useState([]);
  const [showSnackMessage, setShowSnackMessage] = useState(false);
  const [landingDownloadProgress, setLandingDownloadProgress] = useState(false);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const mountedRef = React.useRef(true);
  const transcriptListenerRef = React.useRef(null);
  const snackTimeoutRef = React.useRef(null);
  const { primaryIdentification } = usePrimaryIdentification();
  let allowForResumeConversation = false;

  const populateChatHistory = () => {
    let historyFromConfig = [];
    if (
      s360ConfigService &&
      typeof s360ConfigService.chatHistory !== "string" &&
      s360ConfigService.chatHistory
    ) {
      historyFromConfig = s360ConfigService?.chatHistory;
    }
    let newCHMList = [];

    historyFromConfig?.forEach((cHM) => {
      if (cHM?.workitemId && cHM?.ticketId && cHM?.createdAt) {
        newCHMList.push({
          time: convertEpochToDate(cHM.createdAt),
          ticketId: cHM.ticketId,
          status: cHM.status,
          workItemId: cHM.workitemId,
          isActive: cHM.isActive,
        });
      }
    });
    if (!mountedRef.current) return;
    setTableDataOld(newCHMList);
    setLoadingHistory(false);
  };

  const submissionApiCallPromise = () => {
    return new Promise((resolve, reject) => {
      apiService
        .submitFormData(s360ConfigService.getConfig().s360UserConfig)
        .then((res) => {
          if (res.status === 201) {
            s360ConfigService.thrioConfig.contactDetails = {
              ...s360ConfigService.thrioConfig.contactDetails,
              ...res.data,
            };
            resolve(res.data);
          } else {
            resolve(res.data);
            s360ConfigService.thrioConfig.contactDetails = res.data;
          }

          // moveToPage(PageName.landingPage);
        })
        .catch((err) => {
          reject(err);
          console.error(err);
        });
    });
  };

  useEffect(() => {
    mountedRef.current = true;
    setLoadingHistory(true);
    // Guard: if we've already fetched once in this session, reuse and exit
    // if (s360ConfigService.__historyFetched) {
    //   if (
    //     s360ConfigService &&
    //     typeof s360ConfigService.chatHistory !== "string" &&
    //     s360ConfigService.chatHistory
    //   ) {
    //     populateChatHistory();
    //   } else {
    //     setLoadingHistory(false);
    //   }
    //   return () => {
    //     mountedRef.current = false;
    //   };
    // }
    if (isOnline) {
      if (
        primaryIdentification &&
        s360ConfigService?.thrioConfig?.contactDetails?.id &&
        s360ConfigService?.thrioConfig?.contactDetails?.connections?.value
      ) {
        apiService
          .getTicketsListHistory(
            s360ConfigService?.thrioConfig?.contactDetails?.connections?.value
          )
          .then(async (his) => {
            s360ConfigService.chatHistory = his.data;

            // Call the async function and await its result
            s360ConfigService.activeConversation = await findFirstActiveObject(
              s360ConfigService.chatHistory
            );

            if (s360ConfigService.activeConversation) {
              s360ConfigService.resumedWorkitemId =
                s360ConfigService.activeConversation;
            }

            s360ConfigService.__historyFetched = true;
            populateChatHistory();
          });
      } else if (
        getCookieForContactDetails(s360ConfigService.config.widgetconfigId)
      ) {
        apiService
          .getTicketsListHistory(
            getCookieForContactDetails(s360ConfigService.config.widgetconfigId)
          )
          .then(async (his) => {
            s360ConfigService.chatHistory = his.data;

            // Call the async function and await its result
            s360ConfigService.activeConversation = await findFirstActiveObject(
              s360ConfigService.chatHistory
            );

            if (s360ConfigService.activeConversation) {
              s360ConfigService.resumedWorkitemId =
                s360ConfigService.activeConversation;
            }

            s360ConfigService.__historyFetched = true;
            populateChatHistory();
          });
      } else {
        if (s360ConfigService?.getConfig()) {
          if (s360ConfigService.getConfig().connectToNextiva) {
            if (s360ConfigService.config.s360UserConfig) {
              if (!s360ConfigService.config?.contactId) {
                submissionApiCallPromise()
                  .then((res) => {
                    if (res && res.id && res?.connections?.value) {
                      s360ConfigService.config.contactId = true;
                      apiService
                        .getTicketsListHistory(res?.connections?.value)
                        .then((his) => {
                          s360ConfigService.chatHistory = his.data;

                          // if (s360ConfigService.activeConversation) {
                          //   s360ConfigService.resumedWorkitemId =
                          //     s360ConfigService.activeConversation =
                          //       s360ConfigService.activeConversation.workitemId;
                          // }
                          s360ConfigService.__historyFetched = true;
                          populateChatHistory();
                        });
                    }
                    setLoadingHistory(false);
                  })
                  .catch((err) => {
                    s360ConfigService.config.contactId = true;
                    setLoadingHistory(false);
                  });
              }
              setLoadingHistory(false);
            }
            setLoadingHistory(false);
          } else if (
            s360ConfigService &&
            typeof s360ConfigService.chatHistory !== "string" &&
            s360ConfigService.chatHistory
          ) {
            populateChatHistory();
          }
          setLoadingHistory(false);
        }
      }
    }

    return () => {
      mountedRef.current = false;
    };
  }, [props.isAppOpen, isOnline, primaryIdentification]);

  const handleDownloadClick = (ticketId, downloadKey) => {
    if (downloadKey && downloadKey.trim() !== "") {
      if (userFromLanding) {
        landingPageActions.downloadHistory(ticketId, downloadKey);
        setLandingDownloadProgress(ticketId);
        if (transcriptListenerRef.current) {
          window.removeEventListener(
            "transcriptDownloadDone",
            transcriptListenerRef.current
          );
        }
        const handler = () => {
          if (!mountedRef.current) return;
          setLandingDownloadProgress(false);
        };
        transcriptListenerRef.current = handler;
        window.addEventListener("transcriptDownloadDone", handler);
      } else {
        downloadHistory(ticketId, downloadKey);
      }
    }
  };

  const handleSnackbarClose = () => {
    setShowSnackMessage(false);
  };

  useEffect(() => {
    if (showSnackMessage) {
      if (snackTimeoutRef.current) {
        clearTimeout(snackTimeoutRef.current);
      }
      snackTimeoutRef.current = setTimeout(() => {
        if (!mountedRef.current) return;
        handleSnackbarClose();
      }, 4000);
    }
    return () => {
      if (snackTimeoutRef.current) {
        clearTimeout(snackTimeoutRef.current);
        snackTimeoutRef.current = null;
      }
    };
  }, [showSnackMessage]);

  useEffect(() => {
    return () => {
      if (transcriptListenerRef.current) {
        window.removeEventListener(
          "transcriptDownloadDone",
          transcriptListenerRef.current
        );
        transcriptListenerRef.current = null;
      }
    };
  }, []);

  const startConversation = () => {
    if (s360ConfigService.activeConversation) {
      // s360ConfigService.config.isNewConversation = true;
      const workitem = s360ConfigService.activeConversation;
      // workitem.chatMessages =
      //   s360ConfigService.activeSessions[
      //     s360ConfigService.config.workitemId
      //   ]?.chatMessages;
      s360ConfigService.resumedWorkitemId =
        s360ConfigService.activeConversation;
      landingPageActions.resumeConversation(
        workitem,
        s360ConfigService.thrioConfig?.chatInitRes?.workitemId,
        s360ConfigService?.activeConversationTicketId
      );
    } else {
      s360ConfigService.config.newConversationPreventHistory = true;
      landingPageActions.startNewConversation();
    }
    loadLocalUser();
  };

  const goToExistingConversation = (tData) => {
    if (userFromLanding && tData.workItemId && tData.ticketId) {
      landingPageActions.openHistoryConversation(
        {
          isActive: tData.isActive,
          workitemId: tData.workItemId,
          ticketId: tData.ticketId,
        },
        tData.isActive
      );
    }
    // else if (openHistoryConversation) {
    //   openHistoryConversation({
    //     isActive: tData.isActive,
    //     workitemId: tData.workItemId
    //   }, tData.isActive)
    // }
    // onClickBack();
  };

  return (
    <div
      className="chat-history-container"
      style={
        userFromLanding
          ? {
              margin: "0 -1.6rem -1.6rem -1.6rem",
              width: "calc(100% + 3.2rem)",
              height: "100%",
            }
          : {}
      }
    >
      <div className="chat-history-header">
        {!userFromLanding ? (
          downloadInProgress ? (
            <CircularProgress
              size={15}
              style={{ margin: "6px" }}
              color="inherit"
            />
          ) : (
            <IconButton onClick={(_) => onClickBack()}>
              <ArrowBack fontSize="medium" />
            </IconButton>
          )
        ) : (
          <div style={{ width: "6px" }} />
        )}
        <Typography variant="h6" fontWeight={800}>
          Chat History
        </Typography>
      </div>

      <div className="chat-history-data-table-container">
        <table
          cellPadding="0"
          cellSpacing="0"
          style={{
            borderCollapse: "collapse",
            width: "94%",
            marginLeft: "10px",
            fontSize: "0.85em",
            tableLayout: "fixed",
            border: 0,
          }}
        >
          <tbody style={{ overflowY: "scroll" }}>
            {loadingHistory ? (
              <tr>
                <td
                  colSpan={4}
                  style={{ textAlign: "center", padding: "12px" }}
                >
                  <CircularProgress />
                </td>
              </tr>
            ) : (
              <>
                <tr
                  style={{
                    borderBottom: "1px solid #ccc",
                    lineHeight: "1.8em",
                  }}
                >
                  <th>Time</th>
                  <th>ID</th>
                  <th>Status</th>
                </tr>
                {tableDataOld.map((tData, idx) => (
                  <tr
                    key={tData.ticketId || tData.workItemId || idx}
                    style={{
                      borderBottom: "1px solid #ccc",
                      lineHeight: "1.8em",
                    }}
                  >
                    <td
                      style={{
                        overflow: "hidden",
                        padding: "0 12px 0 0",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {tData.time}
                    </td>
                    <td
                      onClick={(_) => goToExistingConversation(tData)}
                      data-testid={`${DATA_TEST_ID_PREFIX}-${LIVECHAT_CLICK_EVENTS.SHOW_EXISTING_CONVERSATION_HISTORY}`}
                    >
                      {tData.ticketId}
                    </td>
                    <td
                      style={{
                        color: "#005FEC",
                        fontWeight: 800,
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                      onClick={(_) => goToExistingConversation(tData)}
                      data-testid={`${DATA_TEST_ID_PREFIX}-${LIVECHAT_CLICK_EVENTS.SHOW_EXISTING_CONVERSATION_HISTORY}`}
                    >
                      {ticketStatus[tData.status]}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {downloadInProgress === tData.ticketId ||
                      landingDownloadProgress === tData.ticketId ? (
                        <CircularProgress
                          size={15}
                          style={{ margin: "6px" }}
                          color="inherit"
                        />
                      ) : downloadInProgress || landingDownloadProgress ? (
                        <IconButton sx={{ opacity: "0.3" }}>
                          <Download />
                        </IconButton>
                      ) : (
                        <IconButton
                          onClick={(_) =>
                            !downloadInProgress && !landingDownloadProgress
                              ? handleDownloadClick(
                                  tData.ticketId,
                                  tData.workItemId
                                )
                              : setShowSnackMessage(
                                  "Please wait, while we complete the last download"
                                )
                          }
                          data-testid={`${DATA_TEST_ID_PREFIX}-${LIVECHAT_CLICK_EVENTS.LANDING_DOWNLOAD_HISTORY}`}
                        >
                          <Download />
                        </IconButton>
                      )}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={4} style={{ height: "40px" }}>
                    {/* Empty space at bottom */}
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
      {showSnackMessage ? (
        <div className="ncxChatHistorySnackbar">
          <span>{showSnackMessage}</span>
          <span
            className="ncxChatHistorySnackbarClose"
            onClick={handleSnackbarClose}
          >
            Close
          </span>
        </div>
      ) : null}
      <div
        className="chat-history-new-conv-container"
        style={{
          height: userFromLanding ? "80px" : "50px",
        }}
      >
        {landingDownloadProgress ? (
          <CircularProgress />
        ) : userFromLanding ? (
          <button
            disabled={loadingHistory}
            className="chat-history-new-conv-button"
            onClick={startConversation}
          >
            {s360ConfigService.activeConversation
              ? "Resume Conversation"
              : s360ConfigService.config?.configDetails?.startChatText}
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default NCXChatHistory;
